import { useQuery } from "@tanstack/react-query";
import type { MotdChannel, MotdEntry, MotdIndex } from "./types.js";

async function fetchJson<T>(url: string): Promise<T | null> {
  const res = await fetch(url, { credentials: "same-origin" });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`MOTD fetch failed: ${res.status}`);
  return (await res.json()) as T;
}

export function useMotdCurrent(channel: MotdChannel | null) {
  return useQuery({
    queryKey: ["motd", "current", channel],
    enabled: channel != null,
    queryFn: () => fetchJson<MotdEntry>(`/motd/${channel}/current.json`),
    staleTime: 60_000,
  });
}

export function useMotdIndex(channel: MotdChannel | null) {
  return useQuery({
    queryKey: ["motd", "index", channel],
    enabled: channel != null,
    queryFn: () => fetchJson<MotdIndex>(`/motd/${channel}/index.json`),
    staleTime: 60_000,
  });
}

export function useMotdEntry(channel: MotdChannel | null, id: string | null) {
  return useQuery({
    queryKey: ["motd", "entry", channel, id],
    enabled: channel != null && id != null && id.length > 0,
    queryFn: () => fetchJson<MotdEntry>(`/motd/${channel}/${id}.json`),
    staleTime: 60_000,
  });
}
